import styled from '@emotion/styled';
import { alpha, Box, Stack } from '@mui/material';

export const ContactCard = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  border: `1px solid ${theme.colors.border.subtle}`,
  borderRadius: '10px',
  overflow: 'hidden',
  backgroundColor: theme.colors.background.canvas,
}));

export const ContactCardHeader = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: '16px',
  padding: '13px 16px 15px',
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
}));

export const ContactAvatar = styled('img')({
  width: 48,
  height: 48,
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
});

export const AvatarPlaceholder = styled(Stack)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  backgroundColor: theme.colors.brand.solid,
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const ContactFieldRow = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  height: 45,
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
  gap: '10px',
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const CategoryChipsList = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
});

export const CategoryChip = styled(Stack)<{ $color: string }>(({ $color }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '6px',
  padding: '5px 10px',
  borderRadius: '6px',
  backgroundColor: alpha($color, 0.13),
  border: `1px solid ${alpha($color, 0.27)}`,
}));

export const CategoryChipDot = styled('div')<{ $color: string }>(({ $color }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: $color,
  flexShrink: 0,
}));
